@if (ready) {
  <div class="donut2-chart-wrapper">
    <apx-chart
      [series]="series"
      [chart]="chart"
      [labels]="labels"
      [dataLabels]="dataLabels"
      [tooltip]="toolTip"
      [plotOptions]="opt"
      [colors]="colors"
      [stroke]="stroke"
      [legend]="{ show: false }"
    ></apx-chart>

    @if (centerHtmlSafe) {
      <div class="donut-center-html" [innerHTML]="centerHtmlSafe"></div>
    }
  </div>
}
